import { postConfig } from './helpers';

let isEmailValid = false;

const orderItemsWrapper = document.getElementById('order-items-wrapper');
const orderItemsElement = document.getElementById('order-items');

const completeForm = () => {
  const form = document.getElementById('wmdContactForm');
  const requiredFields = form.querySelectorAll('input[required], select[required], textarea[required]');
  let requiredEmpty = 0;
  requiredFields.forEach(field => {
    if (field.value === '' || !field.value) {
      requiredEmpty++;
    }
  });
  return !requiredEmpty;
};

const handleSubmit = async (event) => {
  event.preventDefault();

  if (!isEmailValid) {
    return;
  }

  const form = document.getElementById('wmdContactForm');
  let scrollElement;

  const requiredFields = form.querySelectorAll('input[required], select[required], textarea[required]');
  let requiredEmpty = 0;
  const emptyFields = [];
  requiredFields.forEach(field => {
    if (field.value === '' || !field.value) {
      emptyFields.push(field.name);
      requiredEmpty++;
    }
  });

  const items = document.querySelectorAll('.item-qty');
  let cancelledItems = 0;
  items.forEach(item => {
    if (parseInt(item.value) > 0) {
      cancelledItems++;
    }
  });
  if (cancelledItems === 0) {
    alert('No items have been selected to be cancelled');
    return false;
  }
  if (requiredEmpty) {
    const firstRequiredElementName = emptyFields[0];
    scrollElement = document.querySelector(`input[name='${firstRequiredElementName}']`);
    alert('Please complete all required fields');
    scrollElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    return false;
  }

  const json = serializeFormToJSON(form);

  window.grecaptcha.ready(async function() {
    const token = await window.grecaptcha.execute('6LdRSukqAAAAAIltDZRCSDNcs1gWrQ7wmzh8i_sQ', { action: 'submit' });
    const postData = postConfig({
      greToken: token,
      form: json
    });
    const response = await fetch('/apps/wmd/api/request_cancellation', postData);
    const data = await response.json();

    if (data.status === 200) {
      if (window.wmd?.redirect) {
        window.location.href = window.wmd?.redirectUrl;
      }
      else {
        document.getElementById('successMessage').innerText = data.message;
        document.querySelector('.successful-post').style.display = 'block';
        document.querySelector('.unsuccessful-post').style.display = 'none';
        document.getElementById('wmdContactForm').reset();
        orderItemsElement.textContent = '';
        orderItemsWrapper.style.display = 'none';
        const scrollElement = document.getElementById(`shopify-section-${window.wmd?.scrollTarget}`);
        scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const stickyHeader = document.querySelector('.shopify-section-header-sticky');
        if (stickyHeader) {
          const onScrollEnd = () => {
            stickyHeader.classList.add('shopify-section-header-hidden');
            window.removeEventListener('scrollend', onScrollEnd);
          };
          window.addEventListener('scrollend', onScrollEnd);
        }
      }
    }
    else {
      document.getElementById('failureMessage').innerText = data.message;
      document.querySelector('.unsuccessful-post').style.display = 'block';
      document.querySelector('.successful-post').style.display = 'none';
      const scrollElement = document.getElementById(`shopify-section-${window.wmd?.scrollTarget}`);
      scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const stickyHeader = document.querySelector('.shopify-section-header-sticky');
      if (stickyHeader) {
        const onScrollEnd = () => {
          stickyHeader.classList.add('shopify-section-header-hidden');
          window.removeEventListener('scrollend', onScrollEnd);
        };
        window.addEventListener('scrollend', onScrollEnd);
      }
    }
  });

};

function serializeFormToJSON(form) {
  const formData = new FormData(form);
  const jsonObject = {};

  formData.forEach((value, key) => {
    jsonObject[key] = value;
  });

  return JSON.stringify(jsonObject);
}

const checkEnableSubmitButton = () => {
  const completedForm = completeForm();
  document.getElementById('wmdSubmit').disabled = (isEmailValid === false || completedForm === false);
};

const validateEmailAddress = async (event) => {
  const postData = postConfig({
    email: event.target.value
  });
  const response = await fetch('/apps/wmd/api/validateEmail', postData);
  if (response.status === 200) {
    const data = await response.json();
    if (data.result.verdict !== 'Invalid') {
      isEmailValid = true;
      document.getElementById('emailValid').innerText = '';
    }
    else {
      isEmailValid = false;
      document.getElementById('emailValid').innerText = 'Email address not valid';
    }
  }
  else {
    isEmailValid = false;
    document.getElementById('emailValid').innerText = 'Error validating email address';
  }
  checkEnableSubmitButton();
};

const fetchOrder = async () => {
  const email = document.getElementById('email').value.trim();
  const orderName = document.getElementById('orderName').value.trim();
  if (email === '' || orderName === '') {
    return;
  }

  const postData = postConfig({
    email: email,
    orderName: orderName
  });

  try {
    const response = await fetch('/apps/wmd/api/get_cancellation_order', postData);

    let data =  {};

    try{
      data = await response.json();
    }catch(e){
      data = {};
      console.error(e);
    }
    if (response.ok) {
      document.getElementById('orderId').value = data?.orderId ?? '';
      orderItemsElement.textContent = '';
      makeLineItems(data?.items);
      orderItemsWrapper.style.display = 'block';
    }else{
      orderItemsElement.innerText = data?.message ?? 'Something went wrong - please reload the page and try again.';
      orderItemsWrapper.style.display = 'block';
    }

  }
  catch (e) {
    orderItemsElement.innerText = 'Something went wrong - please reload the page and try again.';
    orderItemsWrapper.style.display = 'block';
    console.error(e);
  }
};

const checkQuantityValid = (event) => {
  const setValue = event.target.value;
  const setMax = event.target.max;
  console.log({setValue}, {setMax});
  if(setValue > setMax) {
    event.target.value = setMax;
  }
  if(setValue < 0){
    event.target.value = 0;
  }
};

const checkNumberValid = (event) => {
  if (['.', ',', 'e', 'E', '+', '-'].includes(event.key)) {
    event.preventDefault();
  }
};

const makeLineItems = (items) => {
  items.forEach((item, i = 1) => {
    const div = document.createElement('div');
    div.className = 'item';
    const img = document.createElement('img');
    img.src = item?.image ?? '';
    img.className = 'item-image';
    const content = document.createElement('div');
    content.className = 'item-content';
    const title = document.createElement('h4');
    title.textContent = item?.title ?? '';
    div.appendChild(img);
    div.appendChild(content);
    content.appendChild(title);

    const inputWrap = document.createElement('div');
    inputWrap.className = 'item-input field';
    const label = document.createElement('label');
    label.className = 'field__label';
    label.textContent = 'Quantity to cancel';
    label.htmlFor = `Cancel: ${item?.title}`;
    const qInput = document.createElement('input');
    qInput.type = 'number';
    qInput.className = 'field__input item-qty';
    qInput.min = '0';
    qInput.max = item?.quantity;
    qInput.step = '1';
    qInput.value = '0';
    qInput.id = `Cancel: ${item?.title}`;
    qInput.name = `Cancel: ${item?.title}`;
    qInput.addEventListener('change', checkQuantityValid);
    qInput.addEventListener('keydown', checkNumberValid);
    inputWrap.appendChild(qInput);
    inputWrap.appendChild(label);
    content.appendChild(inputWrap);
    orderItemsElement.appendChild(div);
    i++;
  });
};

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('email').addEventListener('change', fetchOrder);
  document.getElementById('orderName').addEventListener('change', fetchOrder);
  document.getElementById('wmdSubmit').addEventListener('click', handleSubmit);
  document.getElementById('customerName').addEventListener('change', checkEnableSubmitButton);
  document.getElementById('email').addEventListener('change', checkEnableSubmitButton);
  document.getElementById('orderName').addEventListener('change', checkEnableSubmitButton);
  document.getElementById('message').addEventListener('change', checkEnableSubmitButton);

  if (document.getElementById('email')) {
    const emailInputField = document.getElementById('email');
    emailInputField.addEventListener('change', validateEmailAddress);
  }
  checkEnableSubmitButton();
});
